export const IconMapPinPartnerSingle = (
  animated = false,
  isUnavailable = false,
) => {
  const animationStyle = animated
    ? `
    <style>
      .pin-pulse {
        animation: pinPulse 1.5s ease-in-out infinite;
      }
      @keyframes pinPulse {
        0% { transform: scale(1); opacity: 1; }
        50% { transform: scale(1.2); opacity: 0.8; }
        100% { transform: scale(1); opacity: 1; }
      }
    </style>
  `
    : "";

  const lightColor = isUnavailable ? "#D1D5DB" : "#FDF4A0";
  const darkColor = isUnavailable ? "#9CA3AF" : "#F9E10B";

  return `<svg
    width="50"
    height="47"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="${animated ? "pin-pulse" : ""}"
  >
    ${animationStyle}
    <g filter="url(#a)">
      <path
        d="M4 8a8 8 0 0 1 8-8h26a8 8 0 0 1 8 8v23a8 8 0 0 1-8 8H4V8Z"
        fill="${lightColor}"
      />
      <path
        d="M8 12a8 8 0 0 1 8-8h18a8 8 0 0 1 8 8v15a8 8 0 0 1-8 8H16a8 8 0 0 1-8-8V12Z"
        fill="${darkColor}"
      />
      <g transform="translate(16, 10) scale(0.65)" fill="none" stroke="#3C2110" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z"/>
        <path d="M6 12H4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2"/>
        <path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2"/>
        <path d="M10 6h4"/>
        <path d="M10 10h4"/>
        <path d="M10 14h4"/>
        <path d="M10 18h4"/>
      </g>
    </g>
    <defs>
      <filter
        id="a"
        x="0"
        y="0"
        width="50"
        height="47"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_147_10496"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_147_10496"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
  `;
};
